import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import DeleteGroup from 'modules/posts/components/Groups/Delete'

const DeleteGroupPage = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const location = useLocation()

  const isDashboardUrl = location.pathname.includes(navigation.dashboard.fullPath())

  const handleClose = () => {
    if (isDashboardUrl) {
      navigate(navigation.dashboard.fullPath())
    } else {
      navigate(-1)
    }
  }

  const handleSuccessClose = () => {
    if (isDashboardUrl) {
      navigate(navigation.dashboard.fullPath())
    } else {
      navigate(navigation.communities.fullPath())
    }
  }

  return (
    <DeleteGroup onClose={handleClose} onSuccessClose={handleSuccessClose} groupId={id ?? ''} />
  )
}

export default DeleteGroupPage
